module.exports = __webpack_public_path__ + "assets/helen-logo-1.fe25fba31d07bf0e867e6c43e1543fa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/helen-logo-1.png
// module id = 126
// module chunks = 0